// src/utils.ts
var Any = class {
};
export {
  Any
};
//# sourceMappingURL=react-spring_types.modern.mjs.map